import React from 'react';
import {
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Box,
  Typography,
  Divider,
} from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import MobileThemeVariantPicker from './MobileThemeVariantPicker';

const links = [
  { to: '/m/kayttoehdot', label: 'Käyttöehdot' },
  { to: '/m/tietosuojaseloste', label: 'Tietosuojaseloste' },
  { to: '/m/faq', label: 'Usein kysytyt kysymykset' },
];

export default function MobileDrawer({ open, onClose }) {
  const location = useLocation();

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 280, pt: 2 }} role="presentation">
        <Typography variant="h2" sx={{ px: 2, pb: 1 }}>
          Valikko
        </Typography>
        <Divider />
        <List>
          {links.map((link) => (
            <ListItemButton
              key={link.to}
              component={RouterLink}
              to={link.to}
              selected={location.pathname === link.to}
              onClick={onClose}
              sx={{ minHeight: 48 }}
            >
              <ListItemText primary={link.label} />
            </ListItemButton>
          ))}
          <ListItemButton component={RouterLink} to="/m" onClick={onClose} sx={{ minHeight: 48 }}>
            <ListItemText primary="Hakemus" />
          </ListItemButton>
        </List>
        <Divider />
        <MobileThemeVariantPicker />
      </Box>
    </Drawer>
  );
}
